import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

function GroupCountHeader() {
  return (
    <th className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
      <T kind="Group Count" />
    </th>
  );
}

export default observer(GroupCountHeader);
